export const missingCardMessage = 'Missing billing address on payment card';

export const achievements = {
  rung2: {
    title: 'Full-Price Achievement',
    description: 'Purchased at least two full-priced items in last 36 months',
  },
  rung3: {
    title: 'Wardrobe Achievement',
    description: 'Shopped in 5+ divisions in the last 36 months',
  },
  rung4: {
    title: 'Upsell Achievement',
    description: 'Made at least two single-item purchases of $1,000 or more in last 36 months',
  },
  rung5: {
    title: 'Relationship Achievement',
    description: 'Client has at least one dedicated associate',
  },
  rung6: {
    title: 'Big Ticket Achievement',
    description: 'Made a single-item purchase of $50,000 or more in last 36 months',
  },
};

export const BADGES_FILTER_OPTIONS = [
  {
    label: 'Full-Price Achievement',
    value: 'rung2',
  },
  {
    label: 'Wardrobe Achievement',
    value: 'rung3',
  },
  {
    label: 'Upsell Achievement',
    value: 'rung4',
  },
  {
    label: 'Relationship Achievement',
    value: 'rung5',
  },
  {
    label: 'Big Ticket Achievement',
    value: 'rung6',
  },
];

export const ASSETS_FILTER_OPTIONS = [
  {
    label: 'Promo Card',
    value: 'PROMO',
  },
  {
    label: 'Point Card',
    value: 'POINT',
  },
];
export const PLCCHolderRoles = {
  authorizedUser: 'AU',
  coHolder: 'CH',
  primary: 'PR',
};

export const COMPLETED_ACTION_DELAY_MS = 250;

export const EMPTY_OR_NUMERIC_REGEX = new RegExp('^[0-9]+$|^$');

export const CONTACT_METHODS = [
  { contact: 'Email', label: 'Email', id: 'Email' },
  { contact: 'Call', label: 'Call', id: 'Call' },
  { contact: 'Text', label: 'Text', id: 'Text' },
];

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const REMINDER_VALUES = [
  { label: 'The Day Of', id: 'The Day Of' },
  { label: 'The Day Before', id: 'The Day Before' },
  { label: 'Two Weeks Before', id: 'Two Weeks Before' },
  { label: 'One Month Before', id: 'One Month Before' },
  { label: 'Choose A Date', id: 'Choose A Date' },
];

export const SORT_HEADER_DISPLAY = {
  alphabet: 'Sort: Alphabetical - First Name',
  lastName: 'Sort: Alphabetical - Last Name',
  annualSpendAsc: 'Sort: Annual Spend - Lowest first',
  annualSpendDesc: 'Sort: Annual Spend - Highest first',
  newestFirst: 'Sort: Newest First',
  oldestFirst: 'Sort: Oldest First',
};

const ANNUAL_SORT = [
  {
    label: 'Annual Spend: Lowest first',
    value: 'annualSpendAsc',
  },
  {
    label: 'Annual Spend: Highest first',
    value: 'annualSpendDesc',
  },
];

export const SORTING_OPTIONS_NEW_OLD = [
  {
    label: 'Newest first',
    value: 'newestFirst',
  },
  {
    label: 'Oldest first',
    value: 'oldestFirst',
  },
];

export const SORTING_OPTIONS = [
  {
    label: 'First Name',
    value: 'alphabet',
  },
  {
    label: 'Last Name',
    value: 'lastName',
  },
  ...ANNUAL_SORT,
];

export const SORTING_OPTIONS_POINT_CARD = [
  {
    label: 'Point Card Balance: Lowest first',
    value: 'pointBalanceAsc',
  },
  {
    label: 'Point Card Balance: Highest first',
    value: 'pointBalanceDesc',
  },
];

export const SORTING_OPTIONS_PROMO_CARD = [
  {
    label: 'Promo Card Balance: Lowest first',
    value: 'promoBalanceAsc',
  },
  {
    label: 'Promo Card Balance: Highest first',
    value: 'promoBalanceDesc',
  },
];
